import { OwlDateTimeIntl } from '@danielmoncada/angular-datetime-picker';
import { TranslationService } from '../services/translation.service';

export const createDateTranslations = (translationService: TranslationService): OwlDateTimeIntl => {
  const translations = translationService.getTranslationSync('datePicker.labels');
  const intl = new OwlDateTimeIntl();
  Object.assign(intl, translations);
  return intl;
};
